import { Badge } from '@chakra-ui/react'

type Variant = 'status' | 'severity' | 'sla'

type Props = {
  label: string
  variant?: Variant
}

export function StatusPill({ label, variant = 'status' }: Props) {
  const value = (label ?? '').trim()
  const v = value.toLowerCase()

  /* =======================
   * SLA STATE
   * ======================= */
  if (variant === 'sla') {
    if (v.includes('within')) return pill(value, 'blue')
    if (v.includes('overdue') || v.includes('breach')) return pill(value, 'red')
    return pill(value, 'gray')
  }

  /* =======================
   * SEVERITY
   * ======================= */
  if (variant === 'severity') {
    if (v === 'low') return pill(value, 'blue')
    if (v === 'mid' || v === 'medium') return pill(value, 'cyan')
    if (v === 'high') return pill(value, 'yellow')
    if (v === 'urgent') return pill(value, 'red')
    return pill(value, 'gray')
  }

  /* =======================
   * WORKFLOW STATUS (Request
   * ======================= */

  if (
    v === 'open' ||
    v.includes('in progress') ||
    v.includes('on-going') ||
    v.includes('child ticket') ||
    v.includes('ivr') ||
    v.includes('plotting')
  ) {
    return pill(value, 'cyan')
  }
  // Yellow Pending / Waiting  / For Parts / For Schedule / Review / Permit / Parent Ticket
  if (
    v.includes('waiting') ||
    v.includes('waiting for vendor') ||
    v.includes('for parts') ||
    v.includes('parts') ||
    v.includes('for schedule') ||
    v.includes('schedule') ||
    v.includes('permit') ||
    v.includes('review') ||
    v.includes('parent ticket')
  ) {
    return pill(value, 'yellow')
  }

  // Green Resolved / Closed
  if (v.includes('resolved') || v === 'closed') {
    return pill(value, 'green')
  }

  // red Attention / Unresolved
  if (v.includes('unresolved')) {
    return pill(value, 'red')
  }

  // gray Cancelled / stopped
  if (v.includes('cancel')) {
    return pill(value, 'gray')
  }

  return pill(value, 'gray')
}

/* Shared pill style */
function pill(label: string, scheme: string) {
  return (
    <Badge
      variant="outline"
      colorScheme={scheme}
      borderRadius="md"
      px={3}
      py={1}
      fontWeight="600"
      fontSize="sm"
      textTransform="none"
      maxW="160px"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      title={label} 
    >
      {label}
    </Badge>
  )
}
